import {WithoutSummaryModel} from '../../../../common/entity/dto/plain/withoutSummary.model';
import {ReportComponentSummaryModel} from '../../../report-component/api/entity/reportComponentSummary.model';
import {UserSummary} from '../../../../account/modules/user/api/entity/userSummary.model';

export class ReportAccountComponentModel extends WithoutSummaryModel {
    component: ReportComponentSummaryModel;
    user: UserSummary;
}
